<template>
  <div class="bgReport-ctn pumpReport-ctn" :style="style">
    <a4-horizontal title="Multi-day BG Curve" :bgm-sn-list="bgmSnList" :pda-sn-list="pdaSnList" v-if="showMultiDayMod" :style="multiDayModOrderStyle" :class="{ 'lastA4Page': lastA4Page === 'multiDayModOrderStyle' }">
      <template slot="firstRow">
        <chart-glu-table :values="allData" :diamonds="firstChartMiddleDataListWithoutNumber1" :setting="setting" :no-meal-highlight="!showMealTimeHighlight" :no-horizontal-split-line="!showHorizontalSplitLine" />
        <table-bG-mesurement :value="NumberOfBgMeasurements" :width="bgMesurementWidth"/>
      </template>
      <template slot="secondRow">
        <high-low-event-table :high-event-array="highEventArray" :low-event-array="lowEventArray" />
        <chart-pie :values="multiDayPie" :t2="multiDayPieStr" />
        <chart-bar :rect-nums="barRectNums" :true-counts="multiDayBarTrueCounts" :true-percents="multiDayBarTruePercents" :title="$t('% BGM Reading in target')" />
      </template>
    </a4-horizontal>
    <a4-horizontal title="Box Plot Graph" :bgm-sn-list="bgmSnList" :pda-sn-list="pdaSnList" v-if="showBoxPlot" :style="boxPlotOrderStyle" :class="{ 'lastA4Page': lastA4Page === 'boxPlotOrderStyle' }">
      <template slot="firstRow">
        <div class="boxPlot_firstRow--part1">
          <chart-plot :values="boxPlot" :no-horizontal-split-line="!showHorizontalSplitLine" />
        </div>
        <table-bG-mesurement :value="NumberOfBgMeasurements" :width="bgMesurementWidthPump" />
      </template>
      <template slot="secondRow">
        <high-low-event-table :high-event-array="highEventArray" :low-event-array="lowEventArray" />
        <chart-pie :values="multiDayPie" />
        <chart-bar :rect-nums="barRectNums" :true-counts="multiDayBarTrueCounts" :true-percents="multiDayBarTruePercents" :title="$t('% BGM Reading in target')" />
      </template>
    </a4-horizontal>
    <template v-if="showDailyBehavior">
      <a4-horizontal title="Daily behavior and BG" :bgm-sn-list="bgmSnList" :pda-sn-list="pdaSnList" :no-flex-grow="false" v-for="one in legalDailyList" :key="`dailybehaviorandbg_p_${+new Date()}_${one.date}`" :style="dailyBehaviorOrderStyle" :class="{ 'lastA4Page': lastA4Page === 'dailyBehaviorOrderStyle' }">
        <template slot="firstRow">
          <chart-3-line :value="one" :no-horizontal-split-line="!showHorizontalSplitLine" />
        </template>
        <template slot="secondRow">
          <high-low-event-table :high-event-array="dailyBehaviorHelperGetHighEventData(one)" :low-event-array="dailyBehaviorHelperGetLowEventData(one)" />
          <chart-pie :values="dailyBehaviorHelperGetPieData(one)" />
          <chart-bar :rect-nums="barRectNums" :true-counts="dailyBehaviorHelperGetBarCountsData(one)" :true-percents="dailyBehaviorHelperGetBarData(one)" :title="$t('% BGM Reading in target')" />
        </template>
      </a4-horizontal>
    </template>
    <template v-if="showBGDailyGraph">
     <a4-horizontal :first-row-no-margin-top="false" title="BG Daily Graph" :bgm-sn-list="bgmSnList" :pda-sn-list="pdaSnList" v-for="(oneDayList, pageI) in bgDailyTables" :less-pad="isLongLanguage" :no-flex-grow="true" :key="`bgdailygraph_p${pageI}_${+new Date()}`" :style="bGDailyGraphOrderStyle" :class="{ 'lastA4Page': lastA4Page === 'bGDailyGraphOrderStyle' }">
        <template slot="firstRow">
          <chart-glu-daily-table :values="dailyBGGraphHelperGetTableData(oneDayList)" :show-sum="pageI + 1 === bgDailyTables.length" :sum-row="bgDailyTableSummary" :sum-value="sumValue" />
        </template>
      </a4-horizontal>
    </template>
    <template v-if="showMultiDayPumpGraphPage">
      <a4-horizontal is-pump :title="$t('Multi-day Pump Graph')" :pump-sn-list="pumpSnList" :pda-sn-list="pdaSnList" :no-flex-grow="true" v-for="(page, i) in multiDayPumpGraphPages" :key="`dailygraph_pump_${i}_p_${+new Date()}`" :style="multiDayPumpGraphPageOrderStyle" :class="{ 'lastA4Page': lastA4Page === 'multiDayPumpGraphPageOrderStyle' }">
        <template slot="firstRow">
          <chart-multi-daily-pump :values="page['list']" :warnings="warmMsg" :all-deadline-gaps="allDeadlineGaps" :basal-rate-info-msg="basalRateInfoMsg" :setting="setting" :no-meal-highlight="!showMealTimeHighlight" :no-horizontal-split-line="!showHorizontalSplitLine" :upload-events="dataUploadHis" :basal-rate-base-setting="basalRateBaseSetting" :quickPumpTagList="quickPumpTagList">
            <template slot="chartBar">
              <!-- <chart-bar dont-ratio size-ratio2 :rect-nums="barRectNums" :true-percents="multiDayBarTruePercents" :title="assessmentTimeWithoutDays" /> -->
              <chart-bar dont-ratio size-ratio2 :show-margin-right="false" :rect-nums="barRectNums" :true-percents="page['truePercents']" :true-counts="page['trueCounts']" :title="$t('% BGM Reading in target')" />
            </template>
          </chart-multi-daily-pump>
        </template>
      </a4-horizontal>
    </template>
    <template v-for="(one, oneI) in pumpLegalDailyList" >
      <a4-horizontal v-if="showDailyGraphPumpPage && one && !one.bolusDetailFullPage" is-pump :title="$t('Daily Graph')" :atime="one.date" :pump-sn-list="pumpSnList" :pda-sn-list="pdaSnList" :no-flex-grow="true" :key="`dailygraph_pump_p2_${+new Date()}_${one.date}`" :style="dailyGraphPumpPageOrderStyle" :class="{ 'largerA4': true, 'lastA4Page': lastA4Page === 'dailyBehaviorOrderStyle' &&  oneI === pumpLegalDailyList.length - 1}">
        <template slot="firstRow">
          <div>
            <chart-daily-pump :value="one" :all-deadline-gaps="allDeadlineGaps" :yesterday="helperGetYesterdayOtherData(allDailyListWithFake, one.date, true)" :warnings="warmMsg" :basal-rate-info-msg="basalRateInfoMsg" :basal-rate-base-setting="basalRateBaseSetting" :quickPumpTagList="quickPumpTagList" :upload-events="dataUploadHis" />
            <div class="legends">
              <div class="legend chartDailyPumpLegend twoParts">
                <div class="legendsPart legendsPart--1">
                  <!-- <wt-legend> -->
                  <!--   <template slot="icon"> -->
                  <!--     <svg-icon icon-class="circle-highcolor" /> -->
                  <!--   </template> -->
                  <!--   {{$t('AiDEX High BG')}} -->
                  <!-- </wt-legend> -->
                  <!-- <wt-legend> -->
                  <!--   <template slot="icon"> -->
                  <!--     <svg-icon icon-class="circle-normalcolor" /> -->
                  <!--   </template> -->
                  <!--   {{$t('AiDEX Normal BG')}} -->
                  <!-- </wt-legend> -->
                  <!-- <wt-legend> -->
                  <!--   <template slot="icon"> -->
                  <!--     <svg-icon icon-class="circle-lowcolor" /> -->
                  <!--   </template> -->
                  <!--   {{$t('AiDEX Low BG')}} -->
                  <!-- </wt-legend> -->      
                  <!-- <wt-legend> -->
                  <!--   <template slot="icon"> -->
                  <!--     <svg-icon icon-class="triangle-highcolor" /> -->
                  <!--   </template> -->
                  <!--   {{$t('CGMs High BG')}} -->
                  <!-- </wt-legend> -->
                  <wt-legend>
                    <template slot="icon">
                      <svg-icon icon-class="triangle-normalcolor" />
                    </template>
                    {{$t('CGMs Normal BG')}}
                  </wt-legend>
                  <!-- <wt-legend> -->
                  <!--   <template slot="icon"> -->
                  <!--     <svg-icon icon-class="triangle-lowcolor" /> -->
                  <!--   </template> -->
                  <!--   {{$t('CGMs Low BG')}} -->
                  <!-- </wt-legend> -->
                  <!-- <wt-legend> -->
                  <!--   <template slot="icon"> -->
                  <!--     <svg-icon icon-class="rect-highcolor" /> -->
                  <!--   </template> -->
                  <!--   {{$t('Pump High BG')}} -->
                  <!-- </wt-legend> -->
                  <wt-legend>
                    <template slot="icon">
                      <svg-icon icon-class="rect-normalcolor" />
                    </template>
                    {{$t('Pump Normal BG')}}
                  </wt-legend>
                  <!-- <wt-legend> -->
                  <!--   <template slot="icon"> -->
                  <!--     <svg-icon icon-class="rect-lowcolor" /> -->
                  <!--   </template> -->
                  <!--   {{$t('Pump Low BG')}} -->
                  <!-- </wt-legend> -->
                  <!-- <wt-legend> -->
                  <!--   <template slot="icon"> -->
                  <!--     <svg-icon icon-class="diamond-highcolor" /> -->
                  <!--   </template> -->
                  <!--   {{$t('BG High BG')}} -->
                  <!-- </wt-legend> -->
                  <!-- <wt-legend> -->
                  <!--   <template slot="icon"> -->
                  <!--     <svg-icon icon-class="diamond-normalcolor" /> -->
                  <!--   </template> -->
                  <!--   {{$t('BG Normal BG')}} -->
                  <!-- </wt-legend> -->
                  <!-- <wt-legend> -->
                  <!--   <template slot="icon"> -->
                  <!--     <svg-icon icon-class="diamond-lowcolor" /> -->
                  <!--   </template> -->
                  <!--   {{$t('BG Low BG')}} -->
                  <!-- </wt-legend> -->
                </div>
                <div class="legendsPart legendsPart--2">
                  <div class="legendsPart--title">
                    {{$t('Event Marker')}}
                  </div>
                  <wt-legend>
                    <template slot="icon">
                      <svg-icon icon-class="drug" />
                    </template>
                    {{$t('Medicine')}}
                  </wt-legend>
                  <wt-legend>
                    <template slot="icon">
                      <svg-icon icon-class="apple" />
                    </template>
                    {{$t('Carbs')}}
                  </wt-legend>
                  <wt-legend>
                    <template slot="icon">
                      <svg-icon icon-class="needle" />
                    </template>
                    {{$t('Insulin')}}
                  </wt-legend>
                  <wt-legend>
                    <template slot="icon">
                      <svg-icon icon-class="sport" />
                    </template>
                    {{$t('Exercise')}}
                  </wt-legend>
                </div>
              </div>
              <div class="legend chartDailyPumpLegend">
                <wt-legend>
                  <template slot="icon">
                    <svg-icon icon-class="pumpicon-basalrate" />
                  </template>
                  {{$t('Basal Rate')}}
                </wt-legend>
                <wt-legend>
                  <template slot="icon">
                    <svg-icon icon-class="pumpicon-bolus" />
                  </template>
                  {{$t('Normal Bolus')}}({{$t('Normal Bolus Abbreviation')}})
                </wt-legend>
                <wt-legend>
                  <template slot="icon">
                    <svg-icon icon-class="pumpicon-extendedbolus" />
                  </template>
                  {{$t('Extended Bolus')}}({{$t('Extended Bolus Abbreviation')}})
                </wt-legend>
                <wt-legend>
                  <template slot="icon">
                    <svg-icon icon-class="pumpicon-dual" />
                  </template>
                  {{$t('Dual Wave')}}({{$t('Dual Wave Abbreviation')}})
                </wt-legend>
                <wt-legend>
                  <template slot="icon">
                    <svg-icon icon-class="zebra-3" />
                  </template>
                  {{$t('Temporary Basal Rate')}}
                </wt-legend>
                <wt-legend>
                  <template slot="icon">
                    <svg-icon icon-class="pumpicon-stopline" />
                  </template>
                  {{$t('Stop Line')}}
                </wt-legend>      
                <wt-legend>
                  <template slot="icon">
                    <svg-icon icon-class="pumpicon-alarm3" />
                  </template>
                  {{$t('Alarm')}}
                </wt-legend>
                <wt-legend>
                  <template slot="icon">
                    <svg-icon icon-class="pumpicon-clock" />
                  </template>
                  {{$t('Time Change')}}
                </wt-legend>
                <wt-legend>
                  <template slot="icon">
                    <svg-icon icon-class="pumpicon-needle" />
                  </template>
                  {{$t('Quick Bolus')}}({{$t('Quick Bolus Abbreviation')}})                  
                </wt-legend>
                <wt-legend>
                  <template slot="icon">
                    <svg-icon icon-class="pumpicon-upload2" />
                  </template>
                  {{$t('Upload')}}
                </wt-legend>
                <wt-legend>
                  <template slot="icon">
                    <svg-icon icon-class="pumpicon-resovior3" />
                  </template>
                  {{$t('Reservoir')}}
                </wt-legend>          
                <wt-legend v-for="(change, j) in moduleLegendsHelper(one)" :key="`wtlegend_changemodule_${j}`">
                  <template slot="icon">
                    <svg-icon icon-class="pumpicon-changemodule" />
                    <span :style="{ position: 'absolute', top: '0.4em', fontSize: '0.6em', left: ((change && change.order >= 10) ? '0.21em' : '0.43em') }">{{ change ? change.order : '' }}</span>
                  </template>
                  {{ changeFromI18n(change) }}
                </wt-legend>
              </div>
            </div>            
          </div>
        </template>
        <template slot="secondRow">
          <pump-bolus-detail-table style="flex-shrink: 0;" :value="one" :calculators="calculatorList" :other-data="otherData" :quickPumpTagList="quickPumpTagList" :showMarginRight="false" :full-page-table="false" :is-long-lang="isLongLanguage"/>
          <div class="secondRow--tables">
            <div style="margin: 0 0.5rem;" :style="{ zoom: isLongLanguage ? 0.87 : 0.93}">
              <table-bG-mesurement-v2 :value="helperGetDailyMesurement(one)" :width="bgMesurementWidth" :is-daily="true" :daily-total="NumberOfBgMeasurements.bgTotal" :carbon-total="NumberOfBgMeasurements.carbohydrTotal" h82 />
            </div>
            <div :style="barCtnStyle">
              <chart-bar :rect-nums="barRectNums" :true-counts="dailyBehaviorHelperGetBarCountsData(one)" :true-percents="dailyBehaviorHelperGetBarData(one)" :title="one.date" size-ratio3 />
              <chart-bar :rect-nums="barRectNums" :true-counts="multiDayBarTrueCounts" :true-percents="multiDayBarTruePercents" :title="assessmentTimeWithoutDays" size-ratio3 />
            </div>
          </div>
        </template>
      </a4-horizontal>
      <a4-horizontal v-if="showDailyGraphPumpPage && one && one.bolusDetailFullPage" is-pump :title="$t('Daily Graph')" :atime="one.date" :pump-sn-list="pumpSnList" :pda-sn-list="pdaSnList" :no-flex-grow="true" :key="`dailygraph_pump_p2_bolusDetail_${one.bolusDetailFullPage}_${+new Date()}_${one.date}`" :style="dailyBehaviorOrderStyle" :class="{ 'largerA4': true, 'lastA4Page': lastA4Page === 'dailyBehaviorOrderStyle' &&  oneI === pumpLegalDailyList.length - 1}">
        <template slot="firstRow">          
          <pump-bolus-detail-table style="flex-shrink: 0;" :value="one" :calculators="calculatorList" :other-data="otherData" :quickPumpTagList="quickPumpTagList" :showMarginRight="false" :full-page-table="true" :is-long-lang="isLongLanguage"/>
        </template>
        <template slot="secondRow">        
        </template>
      </a4-horizontal>
    </template>
    <a4-horizontal v-if="showActiveBasalPage" :style="activeBasalPageOrderStyle" :class="{ 'lastA4Page': lastA4Page === 'activeBasalPageOrderStyle' && !showActiveBasalPage2 }" is-pump :title="$t('Active Basal')" :pump-sn-list="pumpSnList" :pda-sn-list="pdaSnList" :no-flex-grow="true">
      <template slot="firstRow">
        <div>
          <chart-pump-basal :value="activeBasalRateBase" />
          <div class="legend chartDailyPumpLegend">
            <wt-legend>
              <template slot="icon">
                <svg-icon icon-class="pumpicon-basalrate" />
              </template>
              {{$t('Basal Rate')}}
            </wt-legend>
          </div>
        </div>
      </template>
      <template slot="secondRow">
        <div style="width: 100%;display: flex;flex-direction: row;justify-content: space-between;">
          <div class="basalRateBaseCtn">
            <div class="basalRateBaseCtn-oneBase--title" :style="{ zoom: zoomRatio }"><span class="basalRateBaseCtn-oneBaseTitle--main">{{$t(basalRateBase1Name)}}</span><span class="basalRateBaseCtn-oneBaseTitle--subtitle">{{$t('Total Dose')}}: {{basalRateBase1TotalDose}}</span></div>
            <!-- <div class="basalRateBaseCtn-oneBase--title" :style="{ zoom: zoomRatio }">{{$t('Total Dose')}}: {{basalRateBase1TotalDose}}</div> -->
            <pump-4-column-table v-if="basalRateBase1TableDataLarger4Columns" size2 :list="basalRateBase1TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-6-column-table v-else-if="basalRateBase1TableDataLarger6Columns" size2 :list="basalRateBase1TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-8-column-table v-else-if="basalRateBase1TableDataLarger8Columns" size2 :list="basalRateBase1TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-two-column-table v-else size2 :column1-unit="'U/h'" :list="basalRateBase1TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
          </div>
          <div class="basalRateBaseCtn">
            <div class="basalRateBaseCtn-oneBase--title" :style="{ zoom: zoomRatio }"><span class="basalRateBaseCtn-oneBaseTitle--main">{{$t(basalRateBase2Name)}}</span><span class="basalRateBaseCtn-oneBaseTitle--subtitle">{{$t('Total Dose')}}: {{basalRateBase2TotalDose}}</span></div>
            <!-- <div class="basalRateBaseCtn-oneBase--title" :style="{ zoom: zoomRatio }">{{$t('Total Dose')}}: {{basalRateBase2TotalDose}}</div> -->
            <pump-4-column-table v-if="basalRateBase2TableDataLarger4Columns" size2 :list="basalRateBase2TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-6-column-table v-else-if="basalRateBase2TableDataLarger6Columns" size2 :list="basalRateBase2TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-8-column-table v-else-if="basalRateBase2TableDataLarger8Columns" size2 :list="basalRateBase2TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-two-column-table v-else size2 :column1-unit="'U/h'" :list="basalRateBase2TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
          </div>
          <div class="basalRateBaseCtn">
            <div class="basalRateBaseCtn-oneBase--title" :style="{ zoom: zoomRatio }"><span class="basalRateBaseCtn-oneBaseTitle--main">{{$t(basalRateBase3Name)}}</span><span class="basalRateBaseCtn-oneBaseTitle--subtitle">{{$t('Total Dose')}}: {{basalRateBase3TotalDose}}</span></div>
            <!-- <div class="basalRateBaseCtn-oneBase--title" :style="{ zoom: zoomRatio }">{{$t('Total Dose')}}: {{basalRateBase3TotalDose}}</div> -->
            <pump-4-column-table v-if="basalRateBase3TableDataLarger4Columns" size2 :list="basalRateBase3TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-6-column-table v-else-if="basalRateBase3TableDataLarger6Columns" size2 :list="basalRateBase3TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-8-column-table v-else-if="basalRateBase3TableDataLarger8Columns" size2 :list="basalRateBase3TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-two-column-table v-else size2 :column1-unit="'U/h'" :list="basalRateBase3TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
          </div>
        </div>
      </template>
    </a4-horizontal>
    <a4-horizontal is-pump :title="$t('Active Basal')" :pump-sn-list="pumpSnList" :pda-sn-list="pdaSnList" :no-flex-grow="true" v-if="showActiveBasalPage2" :style="activeBasalPageOrderStyle" :class="{ 'lastA4Page': lastA4Page === 'activeBasalPageOrderStyle'&& showActiveBasalPage2 }">      
      <template slot="firstRow">
        <div style="width: 100%;display: flex;flex-direction: row;justify-content: space-between;">
          <div class="basalRateBaseCtn">
            <div class="basalRateBaseCtn-oneBase--title" :style="{ zoom: zoomRatio }"><span class="basalRateBaseCtn-oneBaseTitle--main">{{$t(basalRateBase4Name)}}</span><span class="basalRateBaseCtn-oneBaseTitle--subtitle">{{$t('Total Dose')}}: {{basalRateBase4TotalDose}}</span></div>
            <!-- <div class="basalRateBaseCtn-oneBase--title" :style="{ zoom: zoomRatio }">{{$t('Total Dose')}}: {{basalRateBase4TotalDose}}</div> -->
            <pump-4-column-table v-if="basalRateBase4TableDataLarger4Columns" size2 :list="basalRateBase4TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-6-column-table v-else-if="basalRateBase4TableDataLarger6Columns" size2 :list="basalRateBase4TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-8-column-table v-else-if="basalRateBase4TableDataLarger8Columns" size2 :list="basalRateBase4TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-two-column-table v-else size2 :column1-unit="'U/h'" :list="basalRateBase4TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
          </div>
          <div class="basalRateBaseCtn">
            <div class="basalRateBaseCtn-oneBase--title" :style="{ zoom: zoomRatio }"><span class="basalRateBaseCtn-oneBaseTitle--main">{{$t(basalRateBase5Name)}}</span><span class="basalRateBaseCtn-oneBaseTitle--subtitle">{{$t('Total Dose')}}: {{basalRateBase5TotalDose}}</span></div>
            <!-- <div class="basalRateBaseCtn-oneBase--title" :style="{ zoom: zoomRatio }">{{$t('Total Dose')}}: {{basalRateBase5TotalDose}}</div> -->
            <pump-4-column-table v-if="basalRateBase5TableDataLarger4Columns" size2 :list="basalRateBase5TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-6-column-table v-else-if="basalRateBase5TableDataLarger6Columns" size2 :list="basalRateBase5TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-8-column-table v-else-if="basalRateBase5TableDataLarger8Columns" size2 :list="basalRateBase5TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-two-column-table v-else size2 :column1-unit="'U/h'" :list="basalRateBase5TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
          </div>
          <div class="basalRateBaseCtn">
            <div class="basalRateBaseCtn-oneBase--title" :style="{ zoom: zoomRatio }"><span class="basalRateBaseCtn-oneBaseTitle--main">{{$t(basalRateBase6Name)}}</span><span class="basalRateBaseCtn-oneBaseTitle--subtitle">{{$t('Total Dose')}}: {{basalRateBase6TotalDose}}</span></div>
            <!-- <div class="basalRateBaseCtn-oneBase--title" :style="{ zoom: zoomRatio }">{{$t('Total Dose')}}: {{basalRateBase6TotalDose}}</div> -->
            <pump-4-column-table v-if="basalRateBase6TableDataLarger4Columns" size2 :list="basalRateBase6TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-6-column-table v-else-if="basalRateBase6TableDataLarger6Columns" size2 :list="basalRateBase6TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-8-column-table v-else-if="basalRateBase6TableDataLarger8Columns" size2 :list="basalRateBase6TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-two-column-table v-else size2 :column1-unit="'U/h'" :list="basalRateBase6TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
          </div>
        </div>
      </template>
      <template slot="secondRow">
        <div style="width: 100%;display: flex;flex-direction: row;justify-content: space-between;">
          <div class="basalRateBaseCtn">
            <div class="basalRateBaseCtn-oneBase--title" :style="{ zoom: zoomRatio }"><span class="basalRateBaseCtn-oneBaseTitle--main">{{$t(basalRateBase7Name)}}</span><span class="basalRateBaseCtn-oneBaseTitle--subtitle">{{$t('Total Dose')}}: {{basalRateBase7TotalDose}}</span></div>
            <!-- <div class="basalRateBaseCtn-oneBase--title" :style="{ zoom: zoomRatio }">{{$t('Total Dose')}}: {{basalRateBase7TotalDose}}</div> -->
            <pump-4-column-table v-if="basalRateBase7TableDataLarger4Columns" size2 :list="basalRateBase7TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-6-column-table v-else-if="basalRateBase7TableDataLarger6Columns" size2 :list="basalRateBase7TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-8-column-table v-else-if="basalRateBase7TableDataLarger8Columns" size2 :list="basalRateBase7TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
            <pump-two-column-table v-else size2 :column1-unit="'U/h'" :list="basalRateBase7TableData" :row-nums="basalRateBaseSettingRowsMax" :width="512" />
          </div>          
        </div>
      </template>
    </a4-horizontal>
    <template v-if="showBolusCalculatorPage">
      <a4-horizontal is-pump no-title :no-flex-grow="true" :first-row-no-margin-top="false" :pump-sn-list="pumpSnList" :pda-sn-list="pdaSnList" v-for="(one, i) in calculatorSettingPages" :key="`dailygraph_setting_p_${+new Date()}_${i}`" :style="bolusCalculatorPageStyleOrderStyle" :class="{ 'lastA4Page': lastA4Page === 'bolusCalculatorPageStyleOrderStyle' && i === (calculatorSettingPages.length - 1) }">
        <template slot="firstRow">
          <div>
            <div class="tips" :style="{ zoom: zoomRatio, marginTop: 0, marginBottom: Math.floor(zoomRatio * 20) + 'px' }">
              <div class="border"></div>
              <div class="label">{{ $t('Bolus Calculator Setting') }}</div>
            </div>
            <bolus-calculator-setting-table :carbo-list="one['carboList']" :sensitivity-list="one['sensitivityList']" :bg-list="one['bgList']" :extra="one['extra']" :carbo-row-nums="one['carboRowNums']" :bg-row-nums="one['bgRowNums']" :sensitivity-row-nums="one['sensitivityRowNums']"/>
          </div>
          <div :style="{ marginRight: Math.floor(zoomRatio * 50) + 'px', opacity: (i === 0 ? '1' : '0') }">
            <div class="tips" :style="{ zoom: zoomRatio, marginTop: 0, marginBottom: Math.floor(zoomRatio * 20) + 'px' }">
              <div class="border"></div>
              <div class="label">{{ $t('Insulin Delivery Setting') }}</div>
            </div>
            <pump-two-column-table :row-nums="11" :list="insulinDeliverySetting"/>
            <!-- <div class="tips" :style="{ zoom: zoomRatio, marginTop: Math.floor(zoomRatio * 48) + 'px', marginBottom: Math.floor(zoomRatio * 20) + 'px' }"> -->
            <!--   <div class="border"></div> -->
            <!--   <div class="label">{{ $t('Time Change Record') }}</div> -->
            <!-- </div> -->
            <!-- <pump-two-column-table :row-nums="timeChangeRecordListTable1RowNums" :list="timeChangeRecordConstructTableDataHelper(timeChangeRecordListTable1)"/> -->
          </div>
        </template>
        <template slot="secondRow">
        </template>
      </a4-horizontal>
    </template>
    <template v-if="showAlarmRecordPage">
      <a4-horizontal is-pump is-grid :title="$t('Alarm Record')" :pump-sn-list="pumpSnList" :pda-sn-list="pdaSnList" :first-row-no-margin-top="true" v-for="(one, oneI) in alarmRecordPages" :key="`dailygraph_alarm_daily_p1_${+new Date()}_${one.date}_${oneI}`" :class="{ 'lastA4Page': lastA4Page === 'alarmRecordPageOrderStyle' && oneI === (alarmRecordPages.length - 1) }" :style="alarmRecordPageOrderStyle">
        <template slot="firstRow">
          <div :style="{ width: '100%' }">            
            <div class="alarmRecord-oneRow">
              <div class="alarmRecord-oneRow--oneCtn">
                <div class="alarmRecord-date" :style="{ fontSize: zoomRatio * 22 + 'px', marginBottom: Math.floor(zoomRatio * 20) + 'px', marginTop: Math.floor(zoomRatio * 19) + 'px' }">{{ one[0]['date'] | formatTime('YYYY/MM/DD') }}</div>
                <pump-two-column-table :row-nums="one[0]['list'].length" :list="uiDataHelperGetTwoColumnFromAlarmRecords(one[0]['list'])" :width="496" />
              </div>
              <div class="alarmRecord-oneRow--oneCtn">
                <div class="alarmRecord-date" :style="{ opacity: one[1]['isEmpty'] ? '0' : '1',fontSize: zoomRatio * 22 + 'px', marginBottom: Math.floor(zoomRatio * 20) + 'px', marginTop: Math.floor(zoomRatio * 19) + 'px' }">{{ one[1]['date'] | formatTime('YYYY/MM/DD') }}</div>
                <pump-two-column-table :row-nums="one[1]['list'].length" :list="uiDataHelperGetTwoColumnFromAlarmRecords(one[1]['list'])" :width="496" />
              </div>
              <div class="alarmRecord-oneRow--oneCtn">
                <div class="alarmRecord-date" :style="{ opacity: one[2]['isEmpty'] ? '0' : '1',fontSize: zoomRatio * 22 + 'px', marginBottom: Math.floor(zoomRatio * 20) + 'px', marginTop: Math.floor(zoomRatio * 19) + 'px' }">{{ one[2]['date'] | formatTime('YYYY/MM/DD') }}</div>
                <pump-two-column-table :row-nums="one[2]['list'].length" :list="uiDataHelperGetTwoColumnFromAlarmRecords(one[2]['list'])" :width="496" />
              </div>                         
            </div>
          </div>
        </template>
        <template slot="secondRow">
          <div :style="{ width: '100%' }">            
            <div class="alarmRecord-oneRow">
              <div class="alarmRecord-oneRow--oneCtn">
                <div class="alarmRecord-date" :style="{ opacity: one[3]['isEmpty'] ? '0' : '1', fontSize: zoomRatio * 22 + 'px', marginBottom: Math.floor(zoomRatio * 20) + 'px', marginTop: Math.floor(zoomRatio * 19) + 'px' }">{{ one[3]['date'] | formatTime('YYYY/MM/DD') }}</div>
                <pump-two-column-table :row-nums="one[3]['list'].length" :list="uiDataHelperGetTwoColumnFromAlarmRecords(one[3]['list'])" :width="496" />
              </div>
              <div class="alarmRecord-oneRow--oneCtn">
                <div class="alarmRecord-date" :style="{ opacity: one[4]['isEmpty'] ? '0' : '1',fontSize: zoomRatio * 22 + 'px', marginBottom: Math.floor(zoomRatio * 20) + 'px', marginTop: Math.floor(zoomRatio * 19) + 'px' }">{{ one[4]['date'] | formatTime('YYYY/MM/DD') }}</div>
                <pump-two-column-table :row-nums="one[4]['list'].length" :list="uiDataHelperGetTwoColumnFromAlarmRecords(one[4]['list'])" :width="496" />
              </div>
              <div class="alarmRecord-oneRow--oneCtn">
                <div class="alarmRecord-date" :style="{ opacity: one[5]['isEmpty'] ? '0' : '1',fontSize: zoomRatio * 22 + 'px', marginBottom: Math.floor(zoomRatio * 20) + 'px', marginTop: Math.floor(zoomRatio * 19) + 'px' }">{{ one[5]['date'] | formatTime('YYYY/MM/DD') }}</div>
                <pump-two-column-table :row-nums="one[5]['list'].length" :list="uiDataHelperGetTwoColumnFromAlarmRecords(one[5]['list'])" :width="496" />
              </div>                         
            </div>
          </div>
        </template>
      </a4-horizontal>
    </template>
    <template v-if="showTimeChangeRecordPage">
      <a4-horizontal is-pump is-grid :title="$t('Time Change')" :pump-sn-list="pumpSnList" :pda-sn-list="pdaSnList" :first-row-no-margin-top="true" v-for="(one, oneI) in timeChangeRecordPages" :key="`dailygraph_tchange_daily_p1_${+new Date()}_${one.date}_${oneI}`" :class="{ 'lastA4Page': lastA4Page === 'alarmRecordPageOrderStyle' && oneI === (timeChangeRecordPages.length - 1) }" :style="timeChangeRecordPageOrderStyle">
        <template slot="firstRow">
          <div :style="{ width: '100%' }">            
            <div class="alarmRecord-oneRow">
              <div class="alarmRecord-oneRow--oneCtn">
                <div class="alarmRecord-date" :style="{ fontSize: zoomRatio * 22 + 'px', marginBottom: Math.floor(zoomRatio * 20) + 'px', marginTop: Math.floor(zoomRatio * 19) + 'px' }">{{ one[0]['date'] | formatTime('YYYY/MM/DD') }}</div>
                <pump-two-column-table :row-nums="one[0]['list'].length" :list="uiDataHelperGetTwoColumnFromAlarmRecords(one[0]['list'])" :width="496" />
              </div>
              <div class="alarmRecord-oneRow--oneCtn">
                <div class="alarmRecord-date" :style="{ opacity: one[1]['isEmpty'] ? '0' : '1',fontSize: zoomRatio * 22 + 'px', marginBottom: Math.floor(zoomRatio * 20) + 'px', marginTop: Math.floor(zoomRatio * 19) + 'px' }">{{ one[1]['date'] | formatTime('YYYY/MM/DD') }}</div>
                <pump-two-column-table :row-nums="one[1]['list'].length" :list="uiDataHelperGetTwoColumnFromAlarmRecords(one[1]['list'])" :width="496" />
              </div>
              <div class="alarmRecord-oneRow--oneCtn">
                <div class="alarmRecord-date" :style="{ opacity: one[2]['isEmpty'] ? '0' : '1',fontSize: zoomRatio * 22 + 'px', marginBottom: Math.floor(zoomRatio * 20) + 'px', marginTop: Math.floor(zoomRatio * 19) + 'px' }">{{ one[2]['date'] | formatTime('YYYY/MM/DD') }}</div>
                <pump-two-column-table :row-nums="one[2]['list'].length" :list="uiDataHelperGetTwoColumnFromAlarmRecords(one[2]['list'])" :width="496" />
              </div>                         
            </div>
          </div>
        </template>
        <template slot="secondRow">
          <div :style="{ width: '100%' }">            
            <div class="alarmRecord-oneRow">
              <div class="alarmRecord-oneRow--oneCtn">
                <div class="alarmRecord-date" :style="{ opacity: one[3]['isEmpty'] ? '0' : '1', fontSize: zoomRatio * 22 + 'px', marginBottom: Math.floor(zoomRatio * 20) + 'px', marginTop: Math.floor(zoomRatio * 19) + 'px' }">{{ one[3]['date'] | formatTime('YYYY/MM/DD') }}</div>
                <pump-two-column-table :row-nums="one[3]['list'].length" :list="uiDataHelperGetTwoColumnFromAlarmRecords(one[3]['list'])" :width="496" />
              </div>
              <div class="alarmRecord-oneRow--oneCtn">
                <div class="alarmRecord-date" :style="{ opacity: one[4]['isEmpty'] ? '0' : '1',fontSize: zoomRatio * 22 + 'px', marginBottom: Math.floor(zoomRatio * 20) + 'px', marginTop: Math.floor(zoomRatio * 19) + 'px' }">{{ one[4]['date'] | formatTime('YYYY/MM/DD') }}</div>
                <pump-two-column-table :row-nums="one[4]['list'].length" :list="uiDataHelperGetTwoColumnFromAlarmRecords(one[4]['list'])" :width="496" />
              </div>
              <div class="alarmRecord-oneRow--oneCtn">
                <div class="alarmRecord-date" :style="{ opacity: one[5]['isEmpty'] ? '0' : '1',fontSize: zoomRatio * 22 + 'px', marginBottom: Math.floor(zoomRatio * 20) + 'px', marginTop: Math.floor(zoomRatio * 19) + 'px' }">{{ one[5]['date'] | formatTime('YYYY/MM/DD') }}</div>
                <pump-two-column-table :row-nums="one[5]['list'].length" :list="uiDataHelperGetTwoColumnFromAlarmRecords(one[5]['list'])" :width="496" />
              </div>                         
            </div>
          </div>
        </template>
      </a4-horizontal>
    </template>
  </div>
</template>
<script>
import A4Horizontal from '@c/A4Horizontal'
import wtLegend from '@c/Legend'
import ChartMultiDailyPump from '@c/ChartMultiDailyPump'
import ChartDailyPump from '@c/ChartDailyPump'
import ChartPumpBasal from '@c/ChartPumpBasal'
import PumpTwoColumnTable from '@c/PumpTwoColumnTable'
import Pump4ColumnTable from '@c/Pump4ColumnTable'
import Pump6ColumnTable from '@c/Pump6ColumnTable'
import Pump8ColumnTable from '@c/Pump8ColumnTable'
import BolusCalculatorSettingTable from '@c/BolusCalculatorSettingTable'
import PumpBolusDetailTable from '@c/PumpBolusDetailTable'
import { pumpApi } from '@u/api'
import { _basalRateBaseSettingInfosFromValueArray, _getDeadlineGaps } from '@u/reportHelperPump'

import highLowEventTable from '@c/highLowEventTable'
import ChartPie from '@c/ChartPie'
import ChartPlot from '@c/ChartPlot'
import Chart3Line from '@c/Chart3Line'
import ChartGluTable from '@c/ChartGluTable'
import ChartGluDailyTable from '@c/ChartGluDailyTable'
import { bgApi } from '@u/api'

import ChartBar from '@c/ChartBar'
import TableBGMesurement from '@c/TableBGMesurement'
import TableBGMesurementV2 from '@c/TableBGMesurementV2'
import printMixin from '@mx/print'
import pageTitleMixin from '@mx/pageTitle'
import pumpExclusiveMixin from './pumpExclusiveMixin'
import bgExclusiveMixin from './bgExclusiveMixin'
import dayjs from 'dayjs'
import reDrawTrigger from '@mx/reDrawTrigger'
import { isHighGlu, isLowGlu, isNormalGlu, qcopy, findObjIndexInArray, padZero } from '@u'
import { _legalDataReadingsInTargetChart, _legalDataDailyListOneDataDoNotUsedInComputed, _legalDataDailyListOneDataWithPumpInfoDoNotUsedInComputed, _getMergedPumpBigDosageFromRecords, _bgSortOriginDataByDayList } from '@u/reportHelper'
import { _splitBolusDetailDataToTwoPages } from '@u/reportHelperPump'
import { derrorFactory, errorFactory } from '@u/log'
const derror = derrorFactory('Mix.vue', false)
const error = errorFactory('Mix.vue', false)
function _getTablesDataFromDailyList(_list = []) {
  // derror(`_getTablesDataFromDailyList, list`, list)
  const list = _list.slice()
  const max = 14 // 一页，最多14天的数据  
  const l = list.length
  
  const pagesNum = Math.ceil(l / 14)
  const rst = []
  
  for (let i = 0; i < pagesNum; i++) {
    // one page
    const onePage = []
    const leftCount = Math.min((l - i * max), max)
    
    for (let j = 0; j < leftCount; j++) {
      const tmp = qcopy(list[i * max + j])
      if (!tmp) {
        error(`_getTablesDataFromDailyList生成BG Daily Graph数据出错。page i: ${i}, record j: ${j}, max: ${max}, 计算后的index: ${i * max + j}, 而数据源里头(共${l}条记录)这个index上没有数据;`, list)
      } else {
        onePage.push(tmp)        
      }
    }
    
    rst.push(onePage)
  }
  
  derror(`_getTablesDataFromDailyList, rst`, rst)
  return rst
}

function _legalEventArray(arr = []) {
  const legals = arr.filter(obj => +obj.number > 1)
  return legals
}

function _groupArrays(_list = [], oneGroupNum = 1) {
  let list = _list.slice()
  const l = list.length
  if (!l) {
    return []
  }
  
  const groupsNum = Math.floor(l / oneGroupNum)
  const restNum = l % oneGroupNum
  
  const rst = []
  
  let i = 1
  let r = list
  
  do {
    list = r
    
    r = list.splice(oneGroupNum)
    
    rst.push(list)
    i++
  } while (i <= groupsNum)
  
  if (restNum) {
    rst.push(r)
  }
  
  return rst
}

function _f1(orderNum) {
  const { sortedBasalRateBaseSetting = [] } = this
  const tmp = sortedBasalRateBaseSetting[orderNum - 1]
  if (!tmp) return {}
  return tmp
}
function _f2(orderNum) {
  const k = `basalRateBase${orderNum}`
  const base = this[k]
  const name = (base.settingName || ' ')
  const isActive = `${base.isActive}`.trim() === '0' // isActive是0，意味着是active的
  return isActive ? `${name}(${this.$t('Active')})` : `${name}`
}
function _f3(orderNum) {
  const k = `basalRateBase${orderNum}`
  const base = this[k]
  const { basalRateBaseSettingRowsMax } = this
  const { valueArray = '' } = base
  const rst = _basalRateBaseSettingInfosFromValueArray(valueArray, k)
  const l = rst.length
  const num = Math.ceil(l / basalRateBaseSettingRowsMax)
  if (l - basalRateBaseSettingRowsMax > 0) {
    // 分成多列展示
    const all = rst.slice()
    
    const nr = []
    
    rst.splice(basalRateBaseSettingRowsMax)
    const firstColumns = rst
    
    const startOfDay = dayjs().startOf('day')
    const fmt = 'HH:mm'
    
    firstColumns.forEach((obj, i) => {
      if (i < basalRateBaseSettingRowsMax) {
        if (num >= 2) {
          // 计算column2, column3
          const index = i + basalRateBaseSettingRowsMax * 1
          const data = all[index] || { isEmpty: true }
          
          const start = startOfDay.add(data.start, 'hour').format(fmt)
          let end = startOfDay.add(data.end, 'hour').format(fmt)
          
          if (end === '00:00') {
            end = '24:00'
          }
          if (data && data.isEmpty !== true) {
            Object.assign(obj, {
              column2: `${start}-${end}`,
              column3: `${data.value ? data.value : ''}`,
              value2: data.value,
              start2: data.start,
              end2: data.end
            }) 
          } 
        }
        
        if (num >= 3) {
          // 计算column4, column5
          const index = i + basalRateBaseSettingRowsMax * 2
          const data = all[index] || { isEmpty: true }
          
          const start = startOfDay.add(data.start, 'hour').format(fmt)
          let end = startOfDay.add(data.end, 'hour').format(fmt)
          
          if (end === '00:00') {
            end = '24:00'
          }
          if (data && data.isEmpty !== true) {
            Object.assign(obj, {
              column4: `${start}-${end}`,
              column5: `${data.value ? data.value : ''}`,
              value3: data.value,
              start3: data.start,
              end3: data.end
            }) 
          } 
        }
        
        if (num > 3) {
          // 计算column6, column7
          const index = i + basalRateBaseSettingRowsMax * 3
          const data = all[index] || { isEmpty: true }
          
          const start = startOfDay.add(data.start, 'hour').format(fmt)
          let end = startOfDay.add(data.end, 'hour').format(fmt)
          
          if (end === '00:00') {
            end = '24:00'
          }
          if (data && data.isEmpty !== true) {
            Object.assign(obj, {
              column6: `${start}-${end}`,
              column7: `${data.value ? data.value : ''}`,
              value4: data.value,
              start4: data.start,
              end4: data.end
            }) 
          } 
        }
        
        nr.push(obj)
      }
    })
    
    return nr
  }
  
  return rst
}
function _f4(orderNum) {
  const k = `basalRateBase${orderNum}`
  const base = this[k]
  const { basalRateBaseSettingRowsMax } = this
  const { valueArray = '' } = base
  const rst = _basalRateBaseSettingInfosFromValueArray(valueArray, k)
  const l = rst.length
  const num = Math.ceil(l / basalRateBaseSettingRowsMax)
  
  return num === 2
}
function _f5(orderNum) {
  const k = `basalRateBase${orderNum}`
  const base = this[k]
  const { valueArray = '' } = base
  const { basalRateBaseSettingRowsMax } = this
  const rst = _basalRateBaseSettingInfosFromValueArray(valueArray, k)
  const l = rst.length
  const num = Math.ceil(l / basalRateBaseSettingRowsMax)
  
  return num === 3
}

function _f6(orderNum) {
  const k = `basalRateBase${orderNum}`
  const base = this[k]
  const { basalRateBaseSettingRowsMax } = this
  const { valueArray = '' } = base
  const rst = _basalRateBaseSettingInfosFromValueArray(valueArray, k)
  const l = rst.length
  const num = Math.ceil(l / basalRateBaseSettingRowsMax)
  
  return num > 3
}

function _f7(orderNum) {
  const k = `basalRateBase${orderNum}`
  const base = this[k]
  const { valueArray = '' } = base
  const rst = _basalRateBaseSettingInfosFromValueArray(valueArray, k)
  
  let total = 0
  rst.forEach(gap => {
    const { start, end, value } = gap
    const hourV = value
    const duration = end - start
    total += (hourV * duration)
  })
  
  return total.toFixed(1) + 'U/' + this.$t('day')
}

const _codeMaps = { // 前置页面(pancares)如果代码更换或者新增后，这里的字典库逻辑要新增
  multiDayModOrderStyle: 1001,
  boxPlotOrderStyle: 1002,
  dailyBehaviorOrderStyle: 1003,
  bGDailyGraphOrderStyle: 1004,
  multiDayPumpGraphPageOrderStyle: 1005,
  dailyGraphPumpPageOrderStyle: 1006,
  activeBasalPageOrderStyle: 1007,
  bolusCalculatorPageStyleOrderStyle: 1008,
  alarmRecordPageOrderStyle: 1011,
  timeChangeRecordPageOrderStyle: 1009
}

export default {
  name: 'PrintReport',
  mixins: [printMixin, reDrawTrigger, pageTitleMixin, pumpExclusiveMixin, bgExclusiveMixin],
  components: {
    A4Horizontal,
    highLowEventTable,
    ChartBar,
    ChartPie,
    ChartPlot,
    Chart3Line,
    ChartGluTable,
    ChartGluDailyTable,
    TableBGMesurement,
    TableBGMesurementV2,
    wtLegend,
    ChartMultiDailyPump,
    ChartDailyPump,
    PumpBolusDetailTable,
    PumpTwoColumnTable,
    Pump4ColumnTable,
    Pump6ColumnTable,
    Pump8ColumnTable,
    BolusCalculatorSettingTable,
    ChartPumpBasal
  },
  beforeCreate() {
    const $loading = this.$loading({ fullscreen: true })
    
    // const fmt = 'YYYY-MM-DD HH:mm:ssZZ'
    const fmt = 'YYYY-MM-DD'
    const p = Object.assign({}, window._query)
    p.unit = `${p.unit}` === 'mg' ? 1 : 0
    p.timeZone = p.tz
    if (!/\+/.test(p.bgnTime)) {
      p.bgnTime = dayjs(p.bgnTime).format(fmt)      
    }
    if (!/\+/.test(p.endTime)) {
      // p.endTime = dayjs(p.endTime).startOf('day').add(1, 'day').format(fmt)
      p.endTime = dayjs(p.endTime).format(fmt)
    }
    Object.assign(this, {
      _bgnTime: p.bgnTime,
      _endTime: p.endTime
    })
    
    bgApi.getBgReport(p).then((res) => {
      const { data, status } = res
      
      $loading.close()
      this.$nextTick(() => {
        this.loadingInstance = $loading
      })
      
      if (`${status}` === '200') {
        const { code, msg } = data
        
        if (`${code}` !== '200') {
          // 接口报错
          const tip = msg || `server error`
          this.$message.error(this.$t(`${tip}`))
        } else {
          // 接口成功
          const uiDataUpdate = {} // 最后将这个uiDataUpdate通过Object.assign(this, uiDataUpdate)绑定到this上，从而触发数据变化->ui变化
          
          const d = data.data || {}
          const ajaxKeys = ['beforeData', 'afterData', 'allData', 'pumpSn', 'bgmSn', 'pdaSn', 'otherData', 'firstChartMiddleDataList', 'multiDay', 'insulinMean', 'boxPlot', 'dailyList', 'sevenDayReadingsInTarget', 'calculatorList', 'warmMsg', 'basalRateInfoMsg', 'quickPumpTagList', 'basalRateBaseSetting', 'setting', 'pdaSetting', 'dataUploadHis']
          const rstAssignToThis = {}
          ajaxKeys.forEach(k => {
            rstAssignToThis[k] = d[k] 
          })
          
          const { patientInfo = {}, pumpSn = [], bgmSn = [], pdaSn = [], otherData = [], basalRateBaseSetting = [], insulinMean = {}, dailyList = [], multiDay = {}} = d
          
          Object.assign(uiDataUpdate, rstAssignToThis)
          
          uiDataUpdate.multiDay = multiDay
          const { BgEventArray = {}, insulinChart = {}, readingsInTargetChart = {}, NumberOfBgMeasurements = {}} = multiDay          
          uiDataUpdate.NumberOfBgMeasurements = NumberOfBgMeasurements
          
          const { reseviorChangeList = [] } = NumberOfBgMeasurements // reseviorChangeList和otherData组成新的otherData
          
          const legalDailyList = dailyList ? dailyList.filter(_legalDataDailyListOneDataDoNotUsedInComputed) : []
          const _pumpLegalDailyList = dailyList ? dailyList.filter(_legalDataDailyListOneDataWithPumpInfoDoNotUsedInComputed) : []
          const pumpLegalDailyList = _splitBolusDetailDataToTwoPages(_pumpLegalDailyList)

          Object.assign(uiDataUpdate, { legalDailyList, pumpLegalDailyList }, { pumpSnList: pumpSn.filter(v => !!v), pdaSnList: pdaSn.filter(v => !!v), otherData: [...otherData, reseviorChangeList], basalRateBaseSetting: (basalRateBaseSetting.sort((first, second) => first.settingIndex - second.settingIndex)).map((obj, i) => {
            const rst = {
              ...obj
            }
            if (obj && !obj.settingName) {
              rst.settingName = this.$t(`Module`) + `${i + 1}`
            }
            return rst
          }) })         
          
          // High glu event && Low glu event
          const { highArray = [], lowArray = [] } = BgEventArray
          
          Object.assign(uiDataUpdate, {
            bgmSnList: bgmSn.filter(v => !!v), pdaSnList: pdaSn.filter(v => !!v),
            bgDailyTables: _getTablesDataFromDailyList(dailyList),
            highEventArray: _legalEventArray(highArray),
            lowEventArray: _legalEventArray(lowArray)
          })
          
          // chart pie
          if (insulinChart && insulinChart.totalBolus !== undefined && insulinChart.totalBasal !== undefined) {
            const _basal = `${insulinChart.totalBasal}`
            const _bolus = `${insulinChart.totalBolus}`
            const days = this.assessmentTimeDaysNum || 1
            
            uiDataUpdate.multiDayPieStr = insulinMean ? `(${insulinMean})` : ''
            uiDataUpdate.multiDayPie = [{
              value: (_basal / days).toFixed(1),
              name: 'Basal Rate'
            }, {
              value: (_bolus / days).toFixed(1),
              name: 'Bolus'
            }] 
          }
          
          // chart bar
          if (readingsInTargetChart) {
            if (_legalDataReadingsInTargetChart(readingsInTargetChart)) {
              const { veryLow, veryhigh, high, low, target } = readingsInTargetChart
              uiDataUpdate.multiDayBarTruePercents = [+veryLow.percent, +low.percent, +target.percent, +high.percent, +veryhigh.percent]
              uiDataUpdate.multiDayBarTrueCounts = [+veryLow.value, +low.value, +target.value, +high.value, +veryhigh.value]
            }
          }
          
          // 高低血糖
          const { highLimit, lowLimit, patientName } = patientInfo          
          
          if (patientName) {
            this.$store.dispatch('redraw/updateName', patientName)
          }
          this.$store.dispatch('redraw/updateHighAndLowLimit', {
            high: highLimit,
            low: lowLimit
          })
          
          // 有数据了，触发redraw
          this.$store.dispatch('redraw/notifyReDraw')
          
          // if (`${highLimit}` !== '10' || `${lowLimit}` !== '3.9') {
          //   // 该用户不是默认值的高低血糖值
          //   // 需要触发redraw
          //   // 有需要更新的,通知ui进行重新渲染
          // }
          
          Object.assign(this, uiDataUpdate) // 触发ui变化
        }
      }
    })
  },
  data() {
    return {
      // style: {
      //   height: (5 * 21 - 0.1) + 'cm'
      // },
      pageTitleMixinNeedTitle: 'BG & Pump Report',
      mods1: 63, // (6位)二进制表示为: 111111;从右到左，各个位分别表示: Multi-day BG Curve、Box Plot Graph、Daily behavior and BG、BG Daily Graph、是否显示分割线、是否显示高亮三餐
      mods2: 255, // (8位)二进制表示为: 11111111;从右到左，各个位分别表示: Multi-day、Daily Graph、Active Basal、Bolus Calculator Setting、Alarm Record、是否显示分割线(pumpOneDay)、Time Change Record、是否显示三餐高亮
      alarmRecordRowNumsMax: 22,
      basalRateBaseSettingRowsMax: 12,
      loadingInstance: null,
      allData: [],
      pumpSnList: [],
      bgmSnList: [],
      pdaSnList: [],
      boxPlot: [],
      firstChartMiddleDataList: [],
      otherData: [],
      dailyList: [],
      legalDailyList: [],
      bgDailyTables: [],
      NumberOfBgMeasurements: {},
      setting: {}, // 早餐、午餐、晚餐设置的时间
      multiDay: {},
      multiDayPie: [],
      multiDayPieStr: '',
      multiDayBarTruePercents: [],
      multiDayBarTrueCounts: [],
      highEventArray: [],
      lowEventArray: [],
      pumpLegalDailyList: [],
      sevenDayReadingsInTarget: [],
      calculatorList: [],
      warmMsg: [],
      basalRateInfoMsg: [],
      quickPumpTagList: [], // 立即大剂量(用户通过泵体的快捷键打的大剂量)
      basalRateBaseSetting: [],
      pdaSetting: {},
      dataUploadHis: [],
      multiDayModOrderStyle: { order: 20 },
      boxPlotOrderStyle: { order: 20 },
      dailyBehaviorOrderStyle: { order: 20 },
      bGDailyGraphOrderStyle: { order: 20 },
      multiDayPumpGraphPageOrderStyle: { order: 20 },
      dailyGraphPumpPageOrderStyle: { order: 20 },
      activeBasalPageOrderStyle: { order: 20 },
      bolusCalculatorPageStyleOrderStyle: { order: 20 },
      alarmRecordPageOrderStyle: { order: 20 },
      timeChangeRecordPageOrderStyle: { order: 20 }
    }
  },
  // beforeCreate(v1, v2) {
  //   const { query } = this.$route || {}    
  // },
  created() {
    // 获取显示模块
    this.processMods()
    
    // 模块显示顺序
    this.processOrders()
    
    this.processUnitAndLangAndHour(true) // 入参true, 意味者当前是init
  },
  mounted() {
  },
  computed: {
    bgMesurementWidthPump() {
      const { isLongLanguage } = this
      // let rst = isLongLanguage ? 725 : 625
      
      // rst += 120

      const rst = isLongLanguage ? 745 : 745
      // return isLongLanguage ? 725 : 625
      return rst
    },
    lastA4Page() {
      const { multiDayModOrderStyle, boxPlotOrderStyle, dailyBehaviorOrderStyle, bGDailyGraphOrderStyle, multiDayPumpGraphPageOrderStyle, dailyGraphPumpPageOrderStyle, activeBasalPageOrderStyle, bolusCalculatorPageStyleOrderStyle, alarmRecordPageOrderStyle, timeChangeRecordPageOrderStyle } = this
      const _defaultOrders = ['multiDayModOrderStyle', 'boxPlotOrderStyle', 'dailyBehaviorOrderStyle', 'bGDailyGraphOrderStyle', 'multiDayPumpGraphPageOrderStyle', 'dailyGraphPumpPageOrderStyle', 'activeBasalPageOrderStyle', 'bolusCalculatorPageStyleOrderStyle', 'alarmRecordPageOrderStyle', 'timeChangeRecordPageOrderStyle']
      
      // step1, 最大值的order(值越大，渲染时候越靠后)
      const maxOrderNum = _defaultOrders.reduce((prev, itemK) => {
        const item = this[itemK]
        if (item && item.order !== undefined) {
          if (prev - item.order < 0) {
            return item.order
          }          
        }

        return prev
      }, 0)

      const lastPageOrderPages = _defaultOrders.filter(k => {
        const style = this[k] || {}
        return style && style.order === maxOrderNum
      })
      const lastPageOrderPagesOrdered = lastPageOrderPages.sort((first, second) => _defaultOrders.indexOf(second) - _defaultOrders.indexOf(first))
      const lastPage = lastPageOrderPagesOrdered[0]
      console.error(`lastPage: ${lastPage}`)
      return lastPage
    },
    showMultiDayPumpGraphPage() {
      const bits = +this.mods2
      
      return !!(bits & 0b0000001)
    },
    showDailyGraphPumpPage() {
      const bits = +this.mods2
      derror(`showDailyGraphPumpPage: ${!!(bits & 0b0000010)}`)
      return !!(bits & 0b0000010)
    },
    showActiveBasalPage() {
      const bits = +this.mods2
      
      return !!(bits & 0b0000100)
    },
    showActiveBasalPage2() {
      const { showActiveBasalPage, basalRateBaseSetting = [] } = this
      return showActiveBasalPage && basalRateBaseSetting && basalRateBaseSetting.length > 3
    },
    showBolusCalculatorPage() {
      const bits = +this.mods2
      
      return !!(bits & 0b0001000)
    },
    showAlarmRecordPage() {
      const bits = +this.mods2
      
      return !!(bits & 0b0010000) // 16
    },
    showTimeChangeRecordPage() {
      const bits = +this.mods2 //
      
      return !!(bits & 0b01000000) // 64
    },
    showHorizontalSplitLine() { //
      const bits1 = +this.mods1
      
      const rst1 = !!(bits1 & 0b010000)
      
      const bits2 = +this.mods2
      
      const rst2 = !!(bits2 & 0b0100000)
      if (rst1 === !rst2) {
        error(`mods1和mods2，一个要显示水平分割线, 一个不要显示水平分割线。为了逻辑继续，我们就显示水平分割线了;mods1: ${bits1}, mods2: ${bits2}`)
      }
      return rst1 || rst2
    },
    showMealTimeHighlight() {
      const bits1 = +this.mods1
      
      const rst1 = !!(bits1 & 0b100000)
      
      const bits2 = +this.mods2
      
      const rst2 = !!(bits2 & 0b10000000)
      if (rst1 === !rst2) {
        error(`mods1和mods2，一个要高亮mealtime, 一个不要高亮mealtime。为了逻辑继续，我们使用mealtime高亮;mods1: ${bits1}, mods2: ${bits2}`)
      }
      return rst1 || rst2
    },
    barCtnStyle() { // bar的宽度
      const { ds, zoomRatio, isLongLanguage, lfs } = this
      const r = 280 / 1754
      const w = r * ds * zoomRatio * 2
      // const h = 221 / 455 * w
      const rst = {
        marginTop: `${0.5 * lfs}px`,
        marginLeft: `${0.5 * lfs}px`,
        width: `${w + 1}px`
      }
      rst.width = '100%'
      if (isLongLanguage) {
        rst.zoom = 0.9
      }
      // derror(`rst`, rst)
      return rst
    },
    barRectNums() {
      const rst = [54, 70, 180, 250] // 单位是mg/dL时候的值
      const { unit } = this
      
      if (`${unit}`.trim().toLowerCase() !== 'mg/dl') { // mmol/l
        return rst.map(v => +((v / 18).toFixed(1)))
      }
      
      return rst // mg/dL
    },
    // legalDailyList() {
    //   const { dailyList = [] } = this
    //   return dailyList.filter(_legalDataDailyListOneData)
    // },
    style() {
      const rst = {}
      const offset = 0.15 // 每满5页，减少0.1cm; 做了个试验，如果总共6页，那么这个减少的0.1cm不够，从而会最后有一页空白；如果是5页，那么这个减少的0.1cm够用，不会最后多打印一页空白的页面
      
      const bodyR = this.body21CmRatio
      // rst.height = h + 'cm'
      rst.zoom = bodyR
      return rst
    },
    showMultiDayMod() {
      const bits = +this.mods1
      
      return !!(bits & 0b000001)
    },
    showBoxPlot() {
      const bits = +this.mods1
      
      return !!(bits & 0b000010)
    },
    showDailyBehavior() {
      const bits = +this.mods1
      
      return !!(bits & 0b000100)
    },
    showBGDailyGraph() {
      const bits = +this.mods1
      
      return !!(bits & 0b001000)
    }
  },
  methods: {
    changeFromI18n(change = {}) {
      if (change) {
        const fromNotNull = !['null', 'NULL', 'undefined'].includes(`${change.from}`)
        if (fromNotNull) {
          const tpl = this.$t('Change from %1 to %2')
          const target = tpl.replace('%1', change.from).replace('%2', change.to)
          return target
        } else {
          // 简单粗暴，就直接 change to
          const tpl = this.$t('Change to %1')
          const target = tpl.replace('%1', change.to)
          return target
        }
      } else {
        return ''
      }
    },
    dailyBehaviorHelperGetBarData(data = {}) {
      // derror(`dailyBehaviorHelperGetBarData`)
      const { threeChartData = {}} = data
      const { readingsInTargetChart } = threeChartData
      
      let rst = []
      
      if (readingsInTargetChart) {
        if (_legalDataReadingsInTargetChart(readingsInTargetChart)) {
          const { veryLow, veryhigh, high, low, target } = readingsInTargetChart
          rst = [+veryLow.percent, +low.percent, +target.percent, +high.percent, +veryhigh.percent]
        }
      }
      
      return rst
    },
    dailyBehaviorHelperGetBarCountsData(data = {}) {
      const { threeChartData = {}} = data
      const { readingsInTargetChart } = threeChartData
      
      let rst = []
      
      if (readingsInTargetChart) {
        if (_legalDataReadingsInTargetChart(readingsInTargetChart)) {
          const { veryLow, veryhigh, high, low, target } = readingsInTargetChart
          rst = [+veryLow.value, +low.value, +target.value, +high.value, +veryhigh.value]
        }
      }
      
      return rst
    },
    processUnitAndLangAndHour(justInit = false) {
      const _uiNeedUpdate = {
        unit: false,
        lang: false,
        hour24: false
      }
      
      // step1, 判断语言是否need upate
      const _dl = process.env.VUE_APP_I18N_LOCALE || 'en' // default locale
      let nLocale = this.$route.query.lang || _dl // 切语言
      
      const { locale: oldLocale } = this.$i18n
      
      if (`${oldLocale}` !== `${nLocale}`) {
        _uiNeedUpdate.lang = true
      }
      
      // step2, 判断unit是否更新，默认使用单位是 'mmol/l'
      const _du = 'mmol/L'
      const nU = this.$route.query.unit ? `${this.$route.query.unit}`.trim() : _du
      const { unit: oU } = this
      
      if (`${nU}`.trim().toLowerCase() !== `${oU}`.trim().toLowerCase()) {
        _uiNeedUpdate.unit = true
      }
      
      // step3, 判断是否更新时间制，默认使用24小时制
      const _dHour = 24
      const nHour = this.$route.query.hour ? `${this.$route.query.hour}`.trim() : _dHour
      const { hourFormat: oHour } = this
      
      if (+nHour && +nHour !== +oHour) {
        _uiNeedUpdate.hour24 = true
      }
      
      if (_uiNeedUpdate.lang) { // 切语言的逻辑
        // 切语言; dayjs的语言切换，已经在main.js里头设置了
        if (`${nLocale}`.toLowerCase() === 'polish') {
          error(`语言参数，波兰语要传值pl, 不能传值polish;但我目前是支持polish的`)
          nLocale = 'pl'
        }
        
        this.$store.dispatch('redraw/updateLang', nLocale) // 这个dispatch之后的逻辑需要TBC,tbc,mock,dev
        
        // 手动切$i18n的语言库
        this.$i18n.locale = nLocale
        
        // TBC, tbc, dev: 需要切换dayjs的语言库，这个可以放到dispatch之后的逻辑里头?        
      }
      
      if (_uiNeedUpdate.unit) { // 切unit的逻辑;tbc,TBC
        this.$store.dispatch('redraw/updateUnit', nU)
      }
      
      if (_uiNeedUpdate.hour24) { // 切24小时制的逻辑;tbc,TBC
        this.$store.dispatch('redraw/updateHourformat', nHour)
      }
      
      console.error(`[processUnitAndLangAndHour], justInit: ${justInit}, _uiNeedUpdate: ${JSON.stringify(_uiNeedUpdate)}`)
      
      if (!justInit) {
        if (!Object.keys(_uiNeedUpdate).every(v => !!v === false)) {
          console.error(`[processUnitAndLangAndHour]触发redraw/notifyReDraw,从而让页面上的图表重新绘画`)
          // 有需要更新的,通知ui进行重新渲染
          this.$store.dispatch('redraw/notifyReDraw')
        }     
      }
      
      return _uiNeedUpdate
    },
    processMods() {
      // bg
      const _dMods1 = 63 // (6位)二进制表示为: 111111;从右到左，各个位分别表示: Multi-day BG Curve、Box Plot Graph、Daily behavior and BG、BG Daily Graph、是否显示分割线、是否显示高亮三餐
      const mods1 = this.$route.query.mods1 ? +`${this.$route.query.mods1}` : _dMods1
      
      // pump
      const _dMods2 = 255 // (8位)二进制表示为: 11111111;从右到左，各个位分别表示: Multi-day、Daily Graph、Active Basal、Bolus Calculator Setting、Alarm Record、是否显示分割线(pumpOneDay)、Time Change Record、是否显示三餐高亮
      
      const mods2 = this.$route.query.mods2 ? +`${this.$route.query.mods2}` : _dMods2
      
      // 具体逻辑(do action)
      this.mods1 = mods1 // bg
      this.mods2 = mods2 // pump
    },
    processOrders() {
      const os = this.$route.query.orders
      derror(`processOrders, os: ${os}`)
      if (os) {
        const _orders = /,/.test(os) ? os.split(',') : (/%2C/i.test(os) ? os.split('%2C') : os.split(','))
        const orders = _orders.map(v => +v)
        
        const _ordersUi = {}
        
        Object.keys(_codeMaps).forEach(what => {
          const code = _codeMaps[what]
          derror(`顺序, code: ${code}, what: ${what}`)
          if (code) {
            const index = orders.indexOf(+code)
            
            if (index >= 0) {
              // 存在
              _ordersUi[what] = {
                order: index + 1
              }
            }
          }
        })
        derror(`_ordersUi, keys: ${Object.keys(_ordersUi)}, _ordersUi: `, _ordersUi)
        
        // ui 渲染
        Object.assign(this, _ordersUi)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/mixin';
@import '@/styles/variables';  
/*设置默认横向打印*/
@page {
    size: A4 landscape;
    margin-left: 0;
    margin-right: 0;
    margin-top: 0;
    margin-bottom: 0;
}
.bgReport-ctn, .pumpReport-ctn {
    -webkit-print-color-adjust: exact;
    -moz-print-color-adjust: exact;
    color-adjust: exact;
    display: flex;
    /*上面的display:flex,会影响break-before:page或者类似的功能，从而导致pdf生成的时候会坍塌*/
    /* 但是不给flex, order(排序)又无效了. 愁死人，只能让服务器生成pdf的chrome服务升级?目前是chrome89 */
    flex-direction: column;
    /* height: 83.888cm; // tbc,dev: 要根据实际的页数进行调整。21cm * 4页，再小一点，然后通过overflow:hidden，从而使得第五页(也即是空白页消失) */
}
@media print {
    .bgReport-ctn, .pumpReport-ctn {
        overflow: hidden;
        zoom: 1 !important;
    }
}
.line {
    height: 1px;
    background-color: white;
}
.tips {
    @include bBox;
    font-size: 18px;
    font-weight: 500;
    margin-top: 20px;
    line-height: 40px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    position: relative;
    /* left: -22px; */
    .border {
        width: 20px;
        height: 40px;
        background: $colorA4PageTitleGreenBg;
        border-radius: 12px 4px 4px 12px;
        margin-right: 10px;
        background-color: $colorA4PageTitleGreenBg;
    }
    .label {
        color: white;
        background-color: $colorA4PageTitleGreenBg;
        border-radius: 5px;
        padding: 0 20px;
    }
}
.alarmRecord-date {
}
.alarmRecord-oneRow {
    @include flexRow(space-around, flex-start);
}
$pl: $sizePaddingTopLegend;

.legend.chartDailyPumpLegend {
    /* margin-left: $pl * 2; */
    zoom: 0.85;
    margin-top: 4px;
    &.legend--row2 {
        margin-top: $pl;
        margin-bottom: $pl + 4px;
    }
    &.twoParts {
        @include flexRow(space-between, center);
        .legendsPart--title {
            zoom: calc(13 / 22);
            font-size: 16px;
            color: #485465;
            font-weight: 500;
            display: inline-block;
        }
        zoom: 0.85;
    }
    ::v-deep .wtLegend-ctn {
        zoom: calc(13 / 22);
        margin-left: $pl;
        &:first-child {
            margin-left: 0;
        }
    }
    ::v-deep > .wtLegend-ctn {
        /* zoom: calc(16 / 22); */
        margin-left: $pl;
        &:first-child {
            margin-left: 0;
        }
    }
}
.basalRateBaseCtn {
    .basalRateBaseCtn-oneBase--title {
        margin-top: 10px;
        &:first-child {
            margin-top: 10px;
        }
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #050505;

        margin-bottom: 10px;
        > * {
            vertical-align: top;
        }
        .basalRateBaseCtn-oneBaseTitle--main {
            font-weight: bold;
            display: inline-block;
            max-width: 320px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
        }
        .basalRateBaseCtn-oneBaseTitle--subtitle {
            margin-left: 0.8rem;
        }
    }
}
</style>
